import { endOfMonth, startOfMonth } from 'date-fns';
import { CampaignSubSource } from 'utils/constants/campaign';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

// exp_PORTFOLIO-53635_start
type EfficiencyData = Record<
    Exclude<CampaignSubSource, CampaignSubSource.HHTopSearch | CampaignSubSource.HHBanners>,
    EfficiencySource
>;
// exp_PORTFOLIO-53635_end

type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

interface EfficiencySource {
    anyResponseFromUsers: number;
    clicks: number;
    cr: number;
    ctr: number;
    impressions: number;
    newRegistrations: number;
    responseOnClickmeVacancy: number;
    vacancyViews: number;
    vtcr: number;
}

const emptyEfficiency = {
    anyResponseFromUsers: 0,
    clicks: 0,
    cr: 0,
    ctr: 0,
    impressions: 0,
    newRegistrations: 0,
    responseOnClickmeVacancy: 0,
    vacancyViews: 0,
    vtcr: 0,
};

// ----------------------- actions -------------------------------------
const SET_EFFICIENCY_DATES = 'SET_EFFICIENCY_DATES';
const SET_EFFICIENCY_DATA = 'SET_EFFICIENCY_DATA';
const SET_LOAD_EFFICIENCY_DATA = 'SET_LOAD_EFFICIENCY_DATA';

interface PayloadTypes {
    [SET_EFFICIENCY_DATES]: { from: FromDate; to: ToDate };
    [SET_EFFICIENCY_DATA]: EfficiencyData;
    [SET_LOAD_EFFICIENCY_DATA]: IsLoad;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setEfficiencyDates = ActionCreator(SET_EFFICIENCY_DATES);
export const setEfficiencyData = ActionCreator(SET_EFFICIENCY_DATA);
export const setLoadEfficiencyData = ActionCreator(SET_LOAD_EFFICIENCY_DATA);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface EfficiencyState {
    from: FromDate;
    to: ToDate;
    efficiencyData: EfficiencyData;
    isLoad: IsLoad;
}

const EFFICIENCY_INITIAL_STATE: EfficiencyState = {
    from: startOfMonth(previousMonth),
    to: endOfMonth(previousMonth),
    efficiencyData: {
        [CampaignSubSource.HH]: emptyEfficiency,
        [CampaignSubSource.Direct]: emptyEfficiency,
        [CampaignSubSource.YandexSearch]: emptyEfficiency,
        [CampaignSubSource.YandexNetwork]: emptyEfficiency,
        [CampaignSubSource.Adwords]: emptyEfficiency,
        [CampaignSubSource.Social]: emptyEfficiency,
        [CampaignSubSource.Instagram]: emptyEfficiency,
        [CampaignSubSource.Facebook]: emptyEfficiency,
        [CampaignSubSource.VK]: emptyEfficiency,
        [CampaignSubSource.VKAdsVK]: emptyEfficiency,
        [CampaignSubSource.VKAdsOK]: emptyEfficiency,
        [CampaignSubSource.VKAdsNetwork]: emptyEfficiency,
        [CampaignSubSource.VKAdsProject]: emptyEfficiency,
    },
    isLoad: false,
};

export default createReducer<EfficiencyState, PayloadTypes>(EFFICIENCY_INITIAL_STATE, {
    [SET_EFFICIENCY_DATES]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_EFFICIENCY_DATA]: (state, { payload }) => ({
        ...state,
        efficiencyData: payload,
    }),
    [SET_LOAD_EFFICIENCY_DATA]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
